import * as React from "react"
import { observer } from "mobx-react"

import { Box, useTheme } from "@mui/material"

import { useTecDocStore } from "../../../../api/services/TecDoc"
import { useMemo } from "react"
import List, { ListTextItemTypes } from "pages/TecDoc/components/List"
import ListHeading from "pages/TecDoc/components/List/components/ListHeading"
import { useTranslation } from "react-i18next"
import { uniq } from "lodash"
export const namespace = __filename

const Info: React.FC = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const tecDocStore = useTecDocStore()
  const {
    articleList,
    articleAttributes,
    directArticle,
    eanNumber,
    replacedNumber,
  } = tecDocStore

  const generalArticleItems = useMemo(() => {
    const requiredKeys = [
      "articleName",
      "articleNo",
      "articleStateName",
      "eanNumber",
      "replacedNumber",
    ]
    let tempArticleList: ListTextItemTypes[] = []
    let tempDirectArticleList: ListTextItemTypes[] = []
    let tempEanNumber: ListTextItemTypes[] = []
    let tempReplacedNumberList: ListTextItemTypes[] = []

    if (articleList) {
      tempArticleList = Object.entries(articleList).map((item) => {
        return {
          key: item[0],
          subItems: [
            {
              label: requiredKeys.includes(item[0]) ? t(item[0]) : item[0],
              content: String(item[1]),
              docType: item[1]?.docFileTypeName,
            },
          ],
        }
      })
    }
    if (directArticle) {
      tempDirectArticleList = Object.entries(directArticle).map((item) => {
        return {
          key: item[0],
          subItems: [
            {
              label: requiredKeys.includes(item[0]) ? t(item[0]) : item[0],
              content: String(item[1]),
              docType: item[1]?.docFileTypeName,
            },
          ],
        }
      })
    }
    if (eanNumber) {
      tempEanNumber = Object.entries(eanNumber).map((item) => {
        return {
          key: Object.keys(item[1])[0],
          subItems: [
            {
              label: t(Object.keys(item[1])[0]),
              content: String(item[1]?.eanNumber),
              docType: item[1]?.docFileTypeName,
            },
          ],
        }
      })
    }

    if (replacedNumber) {
      tempReplacedNumberList = Object.entries(replacedNumber).map((item) => {
        return {
          key: Object.keys(item[1])[0],
          subItems: [
            {
              label: Object.keys(item[1])[0],
              content: String(item[1]?.replacedNumber),
              docType: item[1]?.docFileTypeName,
            },
          ],
        }
      })
    }

    const tempGeneralArticleList = tempArticleList
      .concat(tempDirectArticleList, tempEanNumber, tempReplacedNumberList)
      .filter((item) => requiredKeys.includes(item.key))

    return uniq(tempGeneralArticleList)
  }, [articleList, directArticle, eanNumber, replacedNumber, t])

  const criteriaItems = useMemo(() => {
    let tempArticleAttributes: ListTextItemTypes[] = []
    if (articleAttributes) {
      tempArticleAttributes = Object.entries(articleAttributes).map((item) => {
        return {
          key: item[1]?.attrName,
          subItems: [
            {
              label: item[1]?.attrName,
              content: item[1]?.attrValue,
              docType: item[1]?.docFileTypeName,
            },
          ],
        }
      })
    }
    return tempArticleAttributes
  }, [articleAttributes])

  return (
    <Box>
      <Box sx={{ paddingBottom: theme.spacing(2) }}>
        <ListHeading
          title={t("infoTitle")}
          caret={"NONE"}
          variant={"PRIMARY"}
        />
      </Box>
      <List
        from="info"
        type={"TEXT"}
        title={t("general")}
        items={generalArticleItems}
      />
      <Box sx={{ borderTop: "1px solid #eee", margin: "16px 0" }} />
      <List
        from="info"
        type={"TEXT"}
        title={t("criteria")}
        items={criteriaItems}
      />
    </Box>
  )
}

export default observer(Info)
